import CityPageTemplate from "../city-template/CityPageTemplate";
import { laconiaConfig } from "./data";

export default function LaconiaPage() {
  return <CityPageTemplate config={laconiaConfig} />;
}